import MiddlePanel from 'Components/MiddlePanel/MiddlePanel';
import Panel from 'Components/Panel/Panel';
import { useEffect, useState } from 'react';
import ExecuteAxios from 'Components/ExecuteAxios/ExecuteAxios';
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator';
import PanelListDefault from 'Components/PanelListDefault/PanelListDefault';
import ReactDataPickerComp from 'Components/ReactDataPicker/ReactDataPickerComp';
import ComboBox from 'Components/ComboBox/ComboBox';
import OptionsDataByAttributePath from 'Components/Options/optionsData/OptionsDataByAttributePath';
import InputField from 'Components/Input/InputField';
import RemoveIdsNotFound from 'Components/RemoveIdsNotFound/RemoveIdsNotFound';
import LocalTimeFromInstant from 'Components/LocalTimeFromInstant/LocalTimeFromInstant';
import useDebouncedValue from 'Components/UseDebouncedValue/useDebouncedValue';

const EmployesDayAllocated = ({
    onUpdateShowEmployesDayAllocatedPanel,
    showEmployesDayAllocatedPanel
}) => {
    const [productionList, setProductionList] = useState(null);
    const [productionEmployeesList, setEmployesDayAllocatedList] = useState(null);
    const [loadingProduction, setLoadingProduction] = useState(null);
    const [loadingEmployeeProduction, setLoadingEmployeeProduction] = useState(null);
    const [sectors, setSectors] = useState(null);

    const [productionIdsSelected, setProductionIdsSelected] = useState([]);
    const [sectorIdSelected, setSectorIdSelected] = useState('');
    const [employee, setEmployee] = useState('');
    const debouncedEmployee = useDebouncedValue(employee);
    const [selectedDay, setSelectedDay] = useState(new Date());
    const [groupIdSelected, setGroupIdSelected] = useState(null)
    const [groups, setGroups] = useState([]);

    const sectorOptions = OptionsDataByAttributePath(sectors, ['description'], null, true);
    const groupOptions = OptionsDataByAttributePath(groups, ['description'], null, true)

    const attributeListEmployee = [
        { name: "id", isVisible: false },
        { name: "productCode", isVisible: false }
    ];

    useEffect(() => {
        if (showEmployesDayAllocatedPanel) {
            setProductionList(null);
            setEmployesDayAllocatedList(null);
            setProductionIdsSelected([]);
            setSectorIdSelected('');
            setEmployee('');
            setGroupIdSelected(null)
            setSelectedDay(new Date());
        }
    }, [showEmployesDayAllocatedPanel]);

    // O painel fica montado na tela de Produção mesmo fechado: só busca dados quando estiver aberto.
    // Setores e grupos são carregados na primeira abertura.
    useEffect(() => {
        if (!showEmployesDayAllocatedPanel || sectors !== null) {
            return;
        }
        const fetchData = async () => {
            const [sectors, group] = await Promise.all([
                ExecuteAxios.api('get', '/sector'),
                ExecuteAxios.api('get', '/employee-group/lookup/')
            ]);
            setSectors(sectors);
            setGroups(group);
        };
        fetchData();
    }, [showEmployesDayAllocatedPanel]);

    // Ao abrir, o reset dos filtros (selectedDay = new Date()) dispara esta busca
    useEffect(() => {
        if (!showEmployesDayAllocatedPanel) {
            return;
        }
        getProductionRecords();
    }, [sectorIdSelected, debouncedEmployee, selectedDay, groupIdSelected]);

    async function getProductionRecords() {
        try {
            setLoadingProduction(true);
            const parameters = {
                selectedDay: LocalTimeFromInstant.getLocalDateFromInstant(selectedDay),
                sectorId: sectorIdSelected,
                employeeName: debouncedEmployee,
                employeeGroupId: groupIdSelected
            };
            const productionList = await ExecuteAxios.api(
                'get',
                `/production/get-list-productions-with-allocated-employees/`,
                { params: parameters }
            );
            setProductionList(productionList);

            RemoveIdsNotFound.remove(productionList, (value) => {
                setProductionIdsSelected(value);
            }, productionIdsSelected);
        } finally {
            setLoadingProduction(false);
        }
    }

    useEffect(() => {
        if (!showEmployesDayAllocatedPanel) {
            return;
        }
        getEmployesDayAllocatedList();
    }, [productionIdsSelected]);

    async function getEmployesDayAllocatedList() {
        try {
            setLoadingEmployeeProduction(true);
            const parameters = { productionId: productionIdsSelected[0] };
            const productionEmployeesList = await ExecuteAxios.api(
                'get',
                `/production/get-list-allocated-employees-by-production-id/`,
                { params: parameters }
            );
            setEmployesDayAllocatedList(productionEmployeesList);
        } finally {
            setLoadingEmployeeProduction(false);
        }
    }

    const detailAtributesStyle = {
        display: 'flex',
        flexDirection: 'column',
        margin: '10px 10px 5px 10px',
        width: '200px'
    };

    const panelListStyle = {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        width: '100%'
    };

    return (
        <MiddlePanel isVisible={showEmployesDayAllocatedPanel} zIndex={150}>
            <Panel style={{
                width: '910px',
                height: '650px',
                borderRadius: '10px',
                backgroundColor: '#f5f5f5',
                boxShadow: '0px 0px 10px rgba(0, 0, 0, 30%)',
            }}>
                <div style={{ display: 'flex', flexDirection: 'row', height: '100%' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', minWidth: '25%', maxWidth: '25%' }}>
                        <span style={{
                            fontWeight: 'bold',
                            textAlign: 'center',
                            display: 'flex',
                            minHeight: '56px',
                            marginLeft: '10px',
                            fontSize: '1.2em',
                            alignItems: 'center',
                            whiteSpace: 'nowrap'
                        }}>
                            Produções
                        </span>
                        <div style={{ display: 'flex', flexDirection: 'column' }}>

                            <div style={detailAtributesStyle}>
                                <label>Dia</label>
                                <ReactDataPickerComp
                                    selected={selectedDay}
                                    onChange={(date) => setSelectedDay(date)}
                                    wrapperClassName="width-full"
                                    className="validate-attribute width-full cursor-pointer"
                                    setter={selectedDay}
                                />
                            </div>

                            <div style={detailAtributesStyle}>
                                <label>Setor</label>
                                <ComboBox
                                    setAttribute={setSectorIdSelected}
                                    optionsData={sectorOptions}
                                    value={sectorIdSelected}
                                    defaultValue={sectorIdSelected}
                                />
                            </div>

                            <div style={detailAtributesStyle}>
                                <label>Grupo</label>
                                <ComboBox setAttribute={setGroupIdSelected}
                                    optionsData={groupOptions}
                                    value={groupIdSelected}
                                    defaultValue={groupIdSelected}
                                />
                            </div>

                            <div style={detailAtributesStyle}>
                                <label>Colaborador</label>
                                <InputField
                                    setAttribute={setEmployee}
                                    value={employee}
                                />
                            </div>
                        </div>

                        <Panel style={panelListStyle} recordsSelected={[]}>
                            <LoadingIndicator loaded={!loadingProduction}>
                                <PanelListDefault
                                    onUpdateIdSelected={setProductionIdsSelected}
                                    idsSelected={productionIdsSelected}
                                    data={productionList}
                                    showEmptyImg={false}
                                />
                            </LoadingIndicator>
                        </Panel>
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', minWidth: '75%', maxWidth: '75%' }}>
                        <Panel
                            titlePage={'Colaboradores alocados'}
                            style={panelListStyle}
                            canViewCRUD={true}
                            deleteFunction={() => onUpdateShowEmployesDayAllocatedPanel(false)}
                            deleteNameButton="Fechar"
                            canDelete={true}
                            enableDelete={true}
                            recordsSelected={[]}
                        >
                            <LoadingIndicator loaded={!loadingEmployeeProduction}>
                                <PanelListDefault
                                    onUpdateIdSelected={null}
                                    idsSelected={[]}
                                    data={productionEmployeesList}
                                    attributeList={attributeListEmployee}
                                />
                            </LoadingIndicator>
                        </Panel>
                    </div>
                </div>
            </Panel>
        </MiddlePanel>
    );
};

export default EmployesDayAllocated;
